import { NgIf } from '@angular/common';
import { Component, HostListener, effect, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BusyService } from 'app/core/busy/busy.service';

/** Velo con indicatore di attesa sopra a tutto (anche alle finestre): blocca clic e tastiera finché l'operazione non finisce. */
@Component({
    selector  : 'busy-overlay',
    standalone: true,
    imports   : [NgIf, MatProgressSpinnerModule],
    template  : `
        <div *ngIf="busy.visible() > 0" class="fixed inset-0 z-[10000] flex cursor-wait items-center justify-center bg-black/25 backdrop-blur-[1px]" role="alert" aria-live="assertive" aria-busy="true">
                <div class="flex items-center gap-4 rounded-2xl bg-white px-6 py-4 shadow-2xl">
                    <mat-spinner diameter="28"></mat-spinner>
                    <span class="font-medium text-gray-800">Operazione in corso…</span>
                </div>
        </div>
    `,
})
export class BusyOverlayComponent
{
    protected readonly busy = inject(BusyService);

    constructor()
    {
        // il campo che aveva il cursore lo perde, così non si continua a scrivere sotto al velo
        effect(() =>
        {
            if ( this.busy.visible() > 0 ) (document.activeElement as HTMLElement | null)?.blur?.();
        });
    }

    /** Con il velo acceso nessun tasto arriva ai campi (il carattere non viene inserito). */
    @HostListener('document:keydown', ['$event'])
    onKey(event: KeyboardEvent): void
    {
        if ( this.busy.visible() > 0 )
        {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
